import { Notifications } from '@mui/icons-material';
import { Badge, Box, ClickAwayListener, Grow, IconButton, Popper } from '@mui/material';
import { Suspense, useCallback, useState } from 'react';
import { MenuList } from './MenuList';
import { PopupButton } from './PopupButton';

export const NotificationsPopup = () => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen((previousOpen) => !previousOpen);
    },
    [setAnchorEl, setOpen],
  );

  const onClose = useCallback(() => setOpen(false), [setOpen]);

  return (
    <>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div>
          <Suspense
            fallback={
              <IconButton disabled>
                <Badge badgeContent={0} color="primary">
                  <Notifications />
                </Badge>
              </IconButton>
            }
          >
            <PopupButton onClick={handleClick} />
          </Suspense>
          <Popper
            open={open}
            anchorEl={anchorEl}
            sx={{ zIndex: 9999 }}
            transition
            placement="bottom-end"
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} style={{ transformOrigin: '100% 0 0' }}>
                <div>
                  <MenuList onClose={onClose} />
                </div>
              </Grow>
            )}
          </Popper>
        </div>
      </ClickAwayListener>
    </>
  );
};
